import { render, staticRenderFns } from "./OrderRecordingList.vue?vue&type=template&id=4a4a2810"
import script from "./OrderRecordingList.vue?vue&type=script&lang=js"
export * from "./OrderRecordingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports